import { useCallback, useEffect, useState } from 'react';

import { getEmployees } from '@/modules/employees/redux/EmployeeCRUD';

import { RequestMaterialEmployeeOption } from '../types';

interface UseRequestMaterialEmployeesParams {
  companyId: string;
  skip?: boolean;
  onError?: (message: string) => void;
}

export default function useRequestMaterialEmployees({
  companyId,
  skip = false,
  onError,
}: UseRequestMaterialEmployeesParams) {
  const [employeeOptions, setEmployeeOptions] = useState<RequestMaterialEmployeeOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchEmployees = useCallback(async (company: string) => {
    if (!company || company === 'global') {
      setEmployeeOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await getEmployees({ company, status: 'active', page_size: 500 });
      setEmployeeOptions(
        (response.data.results || []).map((e) => ({
          id: e.id,
          name: e.name,
        }))
      );
    } catch (_error) {
      onError?.('Không thể tải danh sách nhân viên.');
      setEmployeeOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (skip || !companyId) return;
    void fetchEmployees(companyId);
  }, [companyId, skip]);

  return { employeeOptions, loading };
}
